/* Movatic WMS — Frontend | CesarFilho 932048016 */
import StepWizard from '@/components/StepWizard'
import { useToast } from '@/components/Toast'

export default function Receiving() {
  const { show } = useToast()

  return (
    <StepWizard
      title="Recebimento"
      steps={[
        { title: 'Selecionar Documento', content: <Step1/> },
        { title: 'Conferir Itens', content: <Step2/> },
        { title: 'Etiquetar', content: <Step3/> },
        { title: 'Endereçar', content: <Step4/> },
      ]}
      onFinish={() => show({ type: 'success', message: 'Fluxo de Recebimento concluído (mock)' })}
    />
  )
}

function Step1() {
  return (
    <div className="grid gap-2">
      <label className="label">PO/ASN</label>
      <input className="input" placeholder="Código do documento" />
    </div>
  )
}
function Step2() {
  return <div className="text-sm">Escaneie os itens e ajuste quantidades (mock).</div>
}
function Step3() {
  return <div className="text-sm">Impressão de etiquetas de recebimento (mock).</div>
}
function Step4() {
  return <div className="text-sm">Sugerir endereços e confirmar movimentação (mock).</div>
}
